import {
  AUDIO_DOWNLOAD_TYPE
} from '../../core/local-storage.service';

import WaveSurfer from 'wavesurfer.js/dist/wavesurfer';
import MinimapPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.minimap';


const AUDIO_TYPES = ['mp3', 'ogg', 'wav', 'wma'];
const AUDIO_CONTENT_TYPES = {
  'mp3': 'audio/mpeg',
  'ogg': 'audio/ogg',
  'wav': 'audio/wav',
  'wma': 'audio/wma',
};

export class AudioWavesService {

  constructor(
    LocalStorageService,
    $timeout,
    $rootScope,
    CurrentFilterDataService,
    AudioViewerService,
  ) {
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.localStorage = LocalStorageService;
    this.AudioViewerService = AudioViewerService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.current = null;
    this.currentWavesurfer = null;
    this.downloadTypes = AUDIO_TYPES;
    this._downloadType = LocalStorageService.getItem(AUDIO_DOWNLOAD_TYPE);
    this.fileType = this.downloadTypes[0];
    if (this.downloadTypes.indexOf(this.downloadType) === -1) {
      this.downloadType = this.fileType;
    }
    this.lastFinishEventFact = 0;
    this.lastFinishEventDone = false;
    this.wavesurfers = [];
    this.maxLoading = 3;
    this.maxLoaded = 50;
    this.currLoadingCount = 0;
    this.currLoadingIndex = -1;
    this.scrollElement = null;
    this.updatingOffsetTop = false;
  }

  get isPlaying() {
    // return this.current && this.current.currentTime > 0 && !this.current.paused && !this.current.ended && this.current.readyState > 2;
    return this.currentWavesurfer && this.currentWavesurfer.isPlaying();
  }

  loadNextAudio() {}

  playAudio(fact) {
    if (fact && this.AudioViewerService.isWaves(fact) && fact.wavesurfer) {
      this.play(fact.wavesurfer, 0);
      fact.audioLoad = true;
    }
  }

  play(wavesurfer, progress) {
    if (!wavesurfer) {
      console.log('no wavesurfer');
    }
    if (this.currentWavesurfer && this.currentWavesurfer.backend) {
      if (this.currentWavesurfer === wavesurfer) {
        wavesurfer.playPause();
        return;
      }
      if (this.currentWavesurfer.isPlaying()) this.currentWavesurfer.pause();
    }
    this.currentWavesurfer = wavesurfer;
    if (progress !== undefined) wavesurfer.seekTo(progress);
    this.$timeout(() => {
      wavesurfer.playPause();
    }, 100);
  }

  get downloadType() {
    return this._downloadType;
  }

  set downloadType(value) {
    this.localStorage.setItem(AUDIO_DOWNLOAD_TYPE, value);
    this._downloadType = value;
  }

  getSrcType(src, type) {
    return src + (type === 'wma' ? '' : '?type=' + type);
  }
}



// WEBPACK FOOTER //
// ./src/facts/audio-waves/audio-waves.service.js